import { useState, useEffect, useRef, useContext } from 'react';
import HeaderBanner from '../sub-components/HeaderBanner.tsx';
import Footer from "../sub-components/Footer.tsx";
import PageInput from '../sub-components/PageInputCopy.jsx';
import OrderedDataTable from '../sub-components/OrderedDataTableCopy.jsx';
import UserEntitlementRow from '../sub-components/UserEntitlementRow';
import PageContext from '../sub-components/PageContext';
import UserEntitlementModal from '../sub-components/UserEntitlementModal.jsx';
import standardSearch from '../functions/standardSearch';
import applyFilters from '../functions/applyFilters';
import { HttpContext } from '../../api-services/HttpService';
import ExportExcelButton from '../sub-components/ExportExcelButton';
import SnackbarAlert from '../sub-components/SnackbarAlert';
import PageBreadcrumbs from '../sub-components/PageBreadcrumbs.jsx'; 

const UserEntitlementPage = () =>{
    // initialize http context 
    const {
        GET, 
    } = useContext(HttpContext);
    // state for search component
    const [searchValue, setSearchValue] = useState('');
    // state for data table
    const [dataList, setDataList] = useState([]);
    const [tableHeader, setTableHeader] = useState([]);
    const [showDataList, setShowDataList] = useState([]);
    // state for edit modal
    const [editModal, setEditModal] = useState(false);
    const [roleList, setRoleList] = useState([]); 
    const [companyList, setCompanyList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [editUser, setEditUser] = useState();
    // reference to determine initial render
    const initialRender = useRef(true);
    // initialize spinner state
    const [showSpinner, setShowSpinner] = useState(false);
    // initialize snackbar state
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarColor, setSnackbarColor] = useState('info'); 
    const [isMenuLoaded, setIsMenuLoaded] = useState(false);
    const [enableReset, setEnableReset] = useState(false);

    // get data to show in table
    const getUserEntitlementsCounts = () => {
        return new Promise ((resolve, reject) => {
            GET('/user', {}).then(res => {
                setDataList(dataList => dataList = [...res.data.UserEntitlementCounts]); 
                setShowDataList(showDataList => showDataList = [...res.data.UserEntitlementCounts]);
                setTableHeader(tableHeader => tableHeader = res['data']['GuiTableCols']);
                resolve(res);
            }).catch(err => {
                reject(err);
            });
        }); 
    }

    // function wrapper to pass row component to datatable
    const RowComponent = (row, count, tableHeader) =>{
        return( 
            <>
                <UserEntitlementRow row={row} count={count} tableHeader={tableHeader}/>
            </>
        );
    } 

    //function to set spinners, get data, disable spinners
    const getInfo = () => {
        setShowSpinner(showSpinner => showSpinner = true);
        return new Promise((resolve, reject) => {
            // state for table 
            getUserEntitlementsCounts().then(res => {
                setShowSpinner(showSpinner => showSpinner = false);
                resolve(res);
            }).catch(err => {
                setShowSpinner(showSpinner => showSpinner = false);
                reject(err);
            });
        })
    }

    // useEffect to run on initial render
    useEffect(() => {
        getInfo()
    }, []);

    // useEffect to run list of search/filter functions on table data
    useEffect(() => {
        // do not run on initial render
        if (!initialRender.current){
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: standardSearch, value: searchValue, flag: 0, cols: ['userid']},
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(dataList, functionList);
            // update showDataList
            setShowDataList(showDataList => showDataList = filteredList);
        }
        else{
            initialRender.current = false;
        }
    }, [searchValue]);

    // function to set snackbar state
    const snackbarAlert = (show, message, color) => {
        setSnackbarMessage(snackbarMessage => snackbarMessage = message);
        setSnackbarColor(snackbarColor => snackbarColor = color);
        setShowSnackbar(showSnackbar => showSnackbar = show);
    }

    // object to pass variables to PageContext
    const settings = {
        editModal, 
        setEditModal, 
        editUser, 
        setEditUser, 
        getInfo,
        snackbarAlert,
        showSnackbar,
        snackbarColor,
        snackbarMessage,
        setShowSnackbar, 
        getUserEntitlementsCounts
    };

    //reset functionality 
    const resetToDefault = () => {
        setSearchValue('');
    }

    const enableResetAll = () => {
        if(searchValue !== '' ){
            return true;
        }
        return false;
    }

    useEffect(() => {
        if(enableResetAll()){
            setEnableReset(true);
        } else {
            setEnableReset(false);
        }
    }, [searchValue])

    return(
        <div class='summary-page'>
            {/* wrap all children so they can access PageContext variables */}
            <PageContext.Provider value={ settings }>
                {/* header and navslider present on every page */}
                <HeaderBanner />
                {/* breadcrumbs */}
                <div className="pt-1 ps-3 ms-3">
                    <PageBreadcrumbs />
                </div>
                {/* modal that can be activated on page. Default is hidden state */}
                <UserEntitlementModal />
                <SnackbarAlert />
                <div className="container-fluid d-flex flex-column">
                    <div className="d-flex flex-column flex-grow-1 p-2">
                        <div className="pt-3 pb-3 pe-3 mb-3" style={{ borderRadius: '12px', background: '#fff' }}>
                            <div className='d-flex justify-content-between flex-wrap'>
                                <div className='d-flex'>
                                    <div className='ps-2 pe-3'>
                                        <PageInput tag='UserId' showTitle={false} value={searchValue} setValue={setSearchValue} width={'350px'} showSearchIcon={true}/>
                                    </div>
                                    <div className= "pe-3 align-self-center text-decoration-underline" style={{color: `${enableReset ? '#0295BE': '#BDBDBD'}`, cursor: 'pointer', fontFamily: 'Roboto medium'}} onClick={() => enableReset ? resetToDefault(): null}>
                                        Reset All
                                    </div>
                                </div>    
                                <div className='align-self-center'>
                                    <ExportExcelButton tag='ccap-user-entitlements' dataList={showDataList} tableHeader={tableHeader}/>
                                </div>
                            </div>
                        </div>
                        <div className="flex-grow-1" style={{ borderRadius: '12px', background: '#fff' }}>
                                <OrderedDataTable RowComponent={RowComponent} varHeight={'310px'} tableHeader={tableHeader} dataList={showDataList} showSpinner={showSpinner} numToPage={10} sortingEnabled={true} skeletonHeight='28vh'/>
                        </div>
                    </div>
                </div>
                <Footer cssClassName="footer-main-comp"/>
            </PageContext.Provider>
        </div>
    );
}

export default UserEntitlementPage;